<template>
    <header class="header">
        <div class="container-fluid">
            <slot></slot>
        </div>
    </header>
</template>

<script>
export default {};
</script>
